import { useEffect, useState } from "react";
import arrow from "./assets/icons/arrow.svg";
import arrowWhite from "./assets/icons/arrow_white.svg";
import closeIcon from "./assets/icons/close.svg";
import createIcon from "./assets/icons/create_icon.svg";
import loginIcon from "./assets/icons/login_icon.svg";
import manageIcon from "./assets/icons/manage_icon.svg";
import menuIcon from "./assets/icons/menu_icon.svg";
import supportIcon from "./assets/images/support.png";
import ContactFormDialog from "./components/ContactFormDialog/ContactFormDialog";
import LandingPageCousresAvailableSection from "./components/LandingPageCousresAvailableSection/LandingPageCousresAvailableSection";
import siteIcon from "./components/LandingPageCousresAvailableSection/logo-cropped.png";
import "./style/css/main.css";

const apiUrl =
  "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=10&page=1&sparkline=false";

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

const LandingPage = () => {
  const [isContactDialogOpen, setContactDialogOpen] = useState();
  const [isNavbarVisible, setNavbarVisible] = useState(false);

  const handleCloseContactDialog = () => {
    setContactDialogOpen();
  };

  const handleOpenContactDialog = () => {
    setContactDialogOpen(true);
  };
  const toggleNavbar = () => {
    setNavbarVisible((prev) => !prev);
  };

  useEffect(() => {
    let resizeTimer;

    const handleResize = () => {
      document.body.classList.add("resize-animation-stopper");
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.body.classList.remove("resize-animation-stopper");
      }, 400);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className="page-wrapper bg-dark">
        {/* header */}
        <div className="header-wrapper">
          <header className="header flex">
            <div className="container w-full flex-1 flex">
              <div className="header-content w-full flex-1 flex flex-col">
                <nav className="navbar flex items-center justify-between">
                  <div className="brand-and-toggler flex items-center justify-between w-full">
                    <a
                      className="navbar-brand flex items-center"
                      style={{
                        gap: "8px",
                      }}
                    >
                      <img
                        src={siteIcon}
                        style={{
                          width: "30px",
                          height: "30px",
                        }}
                      />
                      <span className="brand-text">
                        عُملا
                        <span className="brand-text">تّيك</span>
                      </span>
                    </a>
                    <button
                      type="button"
                      className="navbar-show-btn"
                      onClick={() => setNavbarVisible(true)}
                    >
                      <img src={menuIcon} alt="Menu Icon" />
                    </button>
                  </div>
                  <div
                    className={`navbar-list-wrapper flex items-center ${
                      isNavbarVisible ? "show" : "hide"
                    }`}
                  >
                    <ul className="nav-list flex items-center">
                      <button
                        type="button"
                        className="navbar-hide-btn"
                        onClick={() => setNavbarVisible(false)}
                      >
                        <img src={closeIcon} alt="close" />
                      </button>
                      {/* <li className="nav-item">
                        <a className="nav-link text-base no-wrap">Buy / Sell</a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link text-base no-wrap">Grow</a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link text-base no-wrap">Market</a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link text-base no-wrap">Business</a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link text-base no-wrap">Support</a>
                      </li> */}
                    </ul>
                    <div className="sign-btns flex items-center">
                      <a
                        href="/login?redirectTo=/app/guide"
                        className="btn text-base"
                        style={{
                          flex: 1,
                          maxWidth: "220px",
                          minWidth: "120px",
                        }}
                      >
                        تسجيل الدخول
                      </a>
                      {/* <a className="btn btn-g-blue-veronica text-base">
                        انضمام
                      </a> */}
                    </div>
                  </div>
                </nav>
                <div className="header-intro flex-1 flex flex-col flex-gap-4 items-center justify-center text-center">
                  <h1
                    style={{
                      lineHeight: "normal",
                    }}
                  >
                    عُمُلاتِك, لنجعل التداول واضح وبسيط
                  </h1>
                  <a
                    className="btn btn-base btn-g-blue-veronica text-base"
                    onClick={handleOpenContactDialog}
                  >
                    ابدا الآن
                  </a>
                </div>
              </div>
            </div>
          </header>
          <div className="info flex items-center justify-center">
            <div className="container">
              <div className="info-content grid">
                <div className="info-item text-center">
                  <img src={loginIcon} alt="Login Icon" />
                  <h3 className="info-item-title">انضم الينا</h3>
                  <p className="text-base text info-item-text">
                    انضم إلى منصتنا اليوم لفتح آفاق جديدة في عالم التداول. نوفر
                    لك الأدوات والإرشادات لتبدأ رحلتك بثقة.
                  </p>
                  <a
                    onClick={handleOpenContactDialog}
                    className="flex-inline items-center btn-link"
                  >
                    <span className="link-text text-lavender text text-base">
                      تواصل معنا
                    </span>
                    <img src={arrow} className="link-icon" alt="link" />
                  </a>
                </div>
                <div className="info-item text-center">
                  <img src={createIcon} alt="" />
                  <h3 className="info-item-title">تعلّم</h3>
                  <p className="text-base text info-item-text">
                    تعلم أساسيات التداول مع خبرائنا واكتسب المهارات التي تحتاجها
                    لتحليل الأسواق واتخاذ قرارات مالية مدروسة.
                  </p>
                  <a
                    onClick={handleOpenContactDialog}
                    className="flex-inline items-center btn-link"
                  >
                    <span className="link-text text-lavender text text-base">
                      لبدأ التعلم
                    </span>
                    <img src={arrow} className="link-icon" />
                  </a>
                </div>
                <div className="info-item text-center">
                  <img src={manageIcon} alt="manage" />
                  <h3 className="info-item-title">إكسب المال</h3>
                  <p className="text-base text info-item-text">
                    استفد من خبرتك واستراتيجياتك لتوليد دخل إضافي وتحقيق أهدافك
                    المالية مع حلولنا المبتكرة.
                  </p>
                  <a
                    onClick={handleOpenContactDialog}
                    className="flex-inline items-center btn-link"
                  >
                    <span className="link-text text-lavender text text-base">
                      فتح محفظة
                    </span>
                    <img src={arrow} className="link-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end of header */}
        <main>
          <section className="page-sc-one flex items-center justify-center">
            <div className="container">
              <div className="sc-one-content text-center">
                <div className="title-wrapper">
                  <h2 className="large-title">
                    دورات ومساقات في مجال العملات الرقمية والتي تستثمر بنفسك
                    وبمدخولك
                  </h2>
                  <p className="text text-base">
                    إكسب المعرفة والخبرة من خلال التداول والتعلّم بمساعدة خبراء
                    اقتصاديين ومتداولين محترفين وإبدأ بكسب المال من خلال
                    التداول.
                  </p>
                  {/* <a
                    onClick={handleOpenContactDialog}
                    className="btn btn-base btn-g-blue-veronica text-base"
                  >
                    إنضم الآن
                  </a> */}
                </div>
              </div>
              <LandingPageCousresAvailableSection />
            </div>
          </section>
          <section className="page-sc-two flex items-center">
            <div className="container">
              <div className="sc-two-content">
                <div className="sc-two-left">
                  <img src={supportIcon} />
                </div>
                <div className="sc-two-right">
                  <h2 className="large-title">
                    خدمة عملاء واستشارة مُتاحة 24/7 لجميع الزبائن وكافة انواع
                    المحافظ
                  </h2>
                  <p className="text text-base">
                    لضمان الربح وتداول ناجع وتقليل المخاطر, نحن نرافقك العملاء
                    خطوة بخطوة, خلال البرنامج التعليمي وخلال فترة التداول حتى
                    تستطيع جني ما تمكّن من الاموال بدون خسارة.
                  </p>
                  <a
                    onClick={handleOpenContactDialog}
                    className="btn btn-base btn-white text-base"
                  >
                    إنضم الآن
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section className="page-sc-fees flex items-center">
            <div className="container">
              <div className="sc-fees-content text-center">
                <div className="title-wrapper">
                  <h2 className="large-title">
                    لا يقتصر الأمر على فهم الرسوم البيانية فقط، بل يشمل أيضًا
                    تحليلها بعمق.
                  </h2>
                  <p className="text text-base">
                    اكتسب المعرفة اللازمة لفهم تحركات السوق واتخاذ قرارات مبنية
                    على تحليل دقيق واحترافي.
                  </p>
                  <a
                    onClick={handleOpenContactDialog}
                    className="flex-inline items-center btn-link"
                  >
                    <span className="link-text text-lavender text text-base">
                      تعلّم الآن
                    </span>
                    <img src={arrow} className="link-icon" />
                  </a>
                </div>
                {/* <div className="data-table-wrapper">
                  <div className="data-table data-table-bg-color">
                    <table className="table">
                      <tbody>
                        <tr className="grid">
                          <td className="flex items-center justify-center text-lg">
                            بيتكوين
                          </td>
                          <td className="flex items-center justify-center text-lavender text-lg">
                            BTC
                          </td>
                          <td className="flex items-center justify-center text-lg">
                            $56,290.30
                          </td>
                          <td className="flex items-center justify-center text-mint text-lg">
                            +1.68%
                          </td>
                          <td className="flex items-center justify-center">
                            <img src={smallGraph1} className="graph-img" />
                          </td>
                          <td className="flex items-center justify-center">
                            <a
                              onClick={handleOpenContactDialog}
                              className="table-link flex items-center"
                            >
                              <span className="link-text no-wrap text-base">
                                تداول الآن
                              </span>
                              <img src={arrowWhite} className="link-icon" />
                            </a>
                          </td>
                        </tr>
                        <tr className="grid">
                          <td className="flex items-center justify-center text-lg">
                            إيثيريوم
                          </td>
                          <td className="flex items-center justify-center text-lavender text-lg">
                            ETH
                          </td>
                          <td className="flex items-center justify-center text-lg">
                            $7,290.30
                          </td>
                          <td className="flex items-center justify-center text-mint text-lg">
                            +4.25%
                          </td>
                          <td className="flex items-center justify-center">
                            <img src={smallGraph2} className="graph-img" />
                          </td>
                          <td className="flex items-center justify-center">
                            <a
                              onClick={handleOpenContactDialog}
                              className="table-link flex items-center"
                            >
                              <span className="link-text no-wrap text-base">
                                تداول الآن
                              </span>
                              <img src={arrowWhite} className="link-icon" />
                            </a>
                          </td>
                        </tr>
                        <tr className="grid">
                          <td className="flex items-center justify-center text-lg">
                            كاردانو
                          </td>
                          <td className="flex items-center justify-center text-lavender text-lg">
                            ADA
                          </td>
                          <td className="flex items-center justify-center text-lg">
                            $1.8
                          </td>
                          <td className="flex items-center justify-center text-mint text-lg">
                            +3.43%
                          </td>
                          <td className="flex items-center justify-center">
                            <img src={smallGraph3} className="graph-img" />
                          </td>
                          <td className="flex items-center justify-center">
                            <a
                              onClick={handleOpenContactDialog}
                              className="table-link flex items-center"
                            >
                              <span className="link-text no-wrap text-base">
                                تداول الآن
                              </span>
                              <img src={arrowWhite} className="link-icon" />
                            </a>
                          </td>
                        </tr>
                        <tr className="grid">
                          <td className="flex items-center justify-center text-lg">
                            بي أن بي
                          </td>
                          <td className="flex items-center justify-center text-lavender text-lg">
                            BNB
                          </td>
                          <td className="flex items-center justify-center text-lg">
                            $0.97
                          </td>
                          <td className="flex items-center justify-center text-mint text-lg">
                            +2.62%
                          </td>
                          <td className="flex items-center justify-center">
                            <img src={smallGraph4} className="graph-img" />
                          </td>
                          <td className="flex items-center justify-center">
                            <a
                              onClick={handleOpenContactDialog}
                              className="table-link flex items-center"
                            >
                              <span className="link-text no-wrap text-base">
                                تداول الآن
                              </span>
                              <img src={arrowWhite} className="link-icon" />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div> */}
              </div>
            </div>
          </section>
          <section className="page-sc-invest flex items-center">
            <div className="container">
              <div className="sc-two-content">
                <div className="sc-two-left">
                  <h2 className="large-title">
                    ابدأ خطوتك الأولى نحو استثمار آمن ومضمون في عالم العملات
                    الرقمية.
                  </h2>
                  <p className="text text-base">
                    ابدأ رحلتك في عالم الاستثمار الرقمي معنا بثقة تامة. شركتنا
                    تضع أمانك في المقام الأول، حيث نوفر لك بيئة استثمار آمنة
                    وشفافة مدعومة بأعلى معايير الحماية. نحن نفخر بكوننا شريكًا
                    موثوقًا للمستثمرين من جميع المستويات، مع فريق متخصص جاهز
                    لدعمك في كل خطوة. من بناء محفظة قوية إلى تحقيق أهدافك
                    المالية، نقدم لك الأدوات الحديثة والإرشادات المهنية التي
                    تضمن لك تجربة استثمار سلسة ومثمرة.
                  </p>
                  <a
                    onClick={handleOpenContactDialog}
                    className="btn btn-base btn-white text-base"
                  >
                    إنضم الآن
                  </a>
                </div>
                <div className="sc-two-right">
                  <img src={supportIcon} />
                </div>
              </div>
            </div>
          </section>
          {/* <section className="page-sc-subscribe">
            <div className="container">
              <div className="sc-subscribe-content text-center">
                <h2 className="large-title">Receive quote</h2>
                <p className="text text-base">
                  Unsubscribe at any time.
                  <span className="text-white">Privacy policy</span>
                </p>
                <form className="flex items-center justify-center">
                  <div className="input-group flex items-center justify-between">
                    <input
                      type="text"
                      className="input-control"
                      placeholder="Email Address"
                    />
                    <button
                      type="submit"
                      className="input-btn flex items-center justify-center"
                    >
                      <img src={arrowWhite} />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section> */}
        </main>
        <footer className="footer">
          <div className="container">
            <div className="footer-content grid">
              <div className="footer-item">
                <p className="text text-base">
                  عُمُلاتِك, هي بوابتك الآمنة والسهلة إلى عالم العملات الرقمية.
                  استمتع بخدماتنا الإحترافية واكسب المال من اليوم الأول بواسطة
                  تعلّم التداول ومرافقة خبراء التداول لك بكل صفقة وصفقة.
                </p>
                <p className="text text-base">
                  إنضم الآن لتحصل على الخبرة اللازمة وتبدأ بكسب المال.
                </p>

                <p className="text text-base">
                  © Microspective Softwares {new Date().getFullYear()}
                </p>
              </div>
              <div className="footer-item">
                <form className="flex items-center">
                  <div className="input-group flex items-center justify-between">
                    <input
                      type="text"
                      className="input-control"
                      placeholder="Email address"
                    />
                    <button
                      type="submit"
                      className="input-btn flex items-center justify-center"
                    >
                      <img src={arrowWhite} />
                    </button>
                  </div>
                </form>
              </div>
              {/* <div className="footer-item">
                <h4 className="footer-item-title text-gray text-base">
                  Privacy Policy and Terms of Services
                </h4>
                <ul className="footer-links">
                  <li>
                    <a className="footer-link text-gray text-base">
                      CoinFlip Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a className="footer-link text-gray text-base">
                      Biometrics Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a className="footer-link text-gray text-base">
                      Financial Policy Notice
                    </a>
                  </li>
                  <li>
                    <a className="footer-link text-gray text-base">
                      Terms of Service
                    </a>
                  </li>
                  <li>
                    <a className="footer-link text-gray text-base">
                      Trade Desk Terms of Service
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </footer>
      </div>
      {isContactDialogOpen && (
        <ContactFormDialog
          open={isContactDialogOpen}
          onClose={handleCloseContactDialog}
          maxWidth="sm"
        />
      )}
    </>
  );
};

export default LandingPage;
